import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Loader } from './Loader';
import { useAuth } from '../hooks';

// The design dashboard has no identity provider. `signIn()` in `hooks/useAuth`
// is an unimplemented TODO, so the landing page cannot authenticate anyone —
// which means that outside production this gate is not a security boundary, it
// is a dead end. Authentication here rests entirely on the fake token seeded in
// `src/index.tsx` under `REACT_APP_USE_MOCKS`, plus the mocked
// `GET /private/provider/self` resolving. If either is missing — the app served
// without the mocks flag, a browser profile where the seed did not run, a mock
// handler that errors — `isAuthenticated` goes false and every route redirects
// to a sign-in screen with no way forward.
//
// So outside production we do not gate. Production keeps the real check, and
// this file is the single choke point for it, so there is no route left behind.
const AUTH_GATE_ENABLED = process.env.REACT_APP_ENV_LABEL === 'production';

export const ProtectedRoute = ({ redirectPath = '/', children }) => {
  const { loading, isAuthenticated } = useAuth();

  // The loading state is still honoured outside production. Under mocks the
  // user resolves before this clears, so components downstream see the same
  // populated `user` they always have — skipping the wait would hand them a
  // null user for a frame and change behaviour rather than just ungating it.
  if (loading) return <Loader loading={loading} />;

  if (AUTH_GATE_ENABLED && !isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};
